export default __webpack_public_path__ + "static/media/Step4-cto.3bbd4d3b.svg";